import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";

export default function ShareRedirect() {
    const { code } = useParams();
    const [error, setError] = useState(false);

    useEffect(() => {
        let active = true;
        api
            .get(`/share/resolve/${code}`)
            .then((r) => {
                if (!active) return;
                const path = r?.data?.target_path || "/";
                window.location.replace(path);
            })
            .catch(() => active && setError(true));
        return () => {
            active = false;
        };
    }, [code]);

    return (
        <div
            data-testid="share-redirect"
            className="min-h-screen flex flex-col items-center justify-center bg-[var(--bg-base)] text-slate-200"
        >
            {error ? (
                <div className="flex flex-col items-center gap-3 text-center">
                    <ShieldAlert size={32} className="text-red-400" />
                    <div className="font-display text-lg">Link not found</div>
                    <p className="text-sm text-slate-500 max-w-xs">
                        This UTSAVA Genesis share link is invalid or has expired.
                    </p>
                    <a href="/" className="btn-primary mt-2" data-testid="share-redirect-home">
                        Open UTSAVA Genesis
                    </a>
                </div>
            ) : (
                <div className="flex flex-col items-center gap-3">
                    <Loader2 size={28} className="text-cyan-400 animate-spin" />
                    <div className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
                        Resolving secure link…
                    </div>
                </div>
            )}
        </div>
    );
}
